import { Button, Icon, Row } from '@amzn/meridian';
import trashTokens from '@amzn/meridian-tokens/base/icon/trash';
import uploadSmallTokens from '@amzn/meridian-tokens/base/icon/upload-large';
import type { FC } from 'react';

type ActionButtonsProps = {
  onRemoveClick: () => void;
  onUploadClick: () => void;
};

export const ActionButtons: FC<ActionButtonsProps> = ({ onRemoveClick, onUploadClick }) => (
  <Row alignmentHorizontal="end">
    <Button onClick={onRemoveClick}>
      <Icon tokens={trashTokens} />
    </Button>
    <Button onClick={onUploadClick}>
      <Icon tokens={uploadSmallTokens} />
    </Button>
  </Row>
);
